// Small, dependency-free formatters used in lists and the reader header.

export function formatAge(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const sec = Math.max(0, (Date.now() - then) / 1000);
  if (sec < 60) return "just now";
  const min = sec / 60;
  if (min < 60) return `${Math.floor(min)}m`;
  const hr = min / 60;
  if (hr < 24) return `${Math.floor(hr)}h`;
  const day = hr / 24;
  if (day < 7) return `${Math.floor(day)}d`;
  const wk = day / 7;
  if (wk < 5) return `${Math.floor(wk)}w`;
  const mo = day / 30;
  if (mo < 12) return `${Math.floor(mo)}mo`;
  const yr = day / 365;
  return `${Math.floor(yr)}y`;
}

export function formatProgress(p: number): string {
  return `${Math.round(p * 100)}%`;
}

export function formatDate(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}
